import { useTranslation } from 'react-i18next'

import { BeforeAfterDiff } from '@/components/v2/tools/amazon-listing/shared/BeforeAfterDiff'

interface RemakeTextDiffProps {
  before: Record<string, unknown> | null
  after: Record<string, unknown> | null
  /** Optional explicit field order; defaults to keys present in `after`. */
  fields?: string[]
}

/** Stringify a single field value — arrays (bullets) joined per line. */
function stringifyField(value: unknown): string {
  if (value == null) return ''
  if (Array.isArray(value)) return value.map((v) => String(v)).join('\n')
  if (typeof value === 'object') return JSON.stringify(value, null, 2)
  return String(value)
}

/**
 * Before -> After text comparison for remake fields (title, bullets, description).
 * Reuses the amazon-listing BeforeAfterDiff card per field.
 */
export function RemakeTextDiff({ before, after, fields }: RemakeTextDiffProps) {
  const { t } = useTranslation()

  if (!after) return null

  const keys = fields ?? Object.keys(after)
  if (keys.length === 0) return null

  return (
    <div className="listing-builder-remake-text-diff space-y-4">
      {keys.map((key) => (
        <BeforeAfterDiff
          key={key}
          label={t(`listingBuilder.remake.fields.${key}`)}
          before={stringifyField(before?.[key])}
          after={stringifyField(after[key])}
        />
      ))}
    </div>
  )
}
